export const BI_BASE_API_URL = process.env.REACT_APP_BI_BASE_API_URL;

// GET - Obtém  anos com dados para exibição do filtro
export const BI_GET_YEARS_ENDPOINT = '/benchmarking/international/years';

// GET - Obtém  grupos de pacientes
export const BI_GET_PATIENTS_GROUPS_ENDPOINT = '/benchmarking/international/patients/groups/items';
